import React from 'react';
import DishesState from './dishesState/DishesState';
import DishesControlPanel from './components/DishesControlPanel/DishesControlPanel';
import Dishes from './components/Dishes/Dishes';
import ModalWindows from './components/ModalWindows/ModalWindows';
import DishFullInfoPage from '../DishFullInfo';
import style from './index.module.scss';

const DishesPage: React.FC = () => {
	return (
		<DishesState>
			<div className={style.container} data-test="DishesPage">
				<DishesControlPanel />
				<Dishes />
				<ModalWindows />
				<DishFullInfoPage />
			</div>
		</DishesState>
	);
};

export default DishesPage;
